import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { ConfiguratorOptionCard } from "~/features/product-configurator/configurator-option-card";
import { type AccessoryGroup } from "~/features/product-configurator/configurator-types";
type Props = {
  group: AccessoryGroup;
  selectedOptionId?: string;
  onSelectOption: (optionId: string) => void;
};
export function ConfiguratorAccessoryGroup({
  group,
  selectedOptionId,
  onSelectOption
}: Props) {
  return <_StyledDiv $_css={[{
    "paddingBottom": "var(--spacing-xl)",
    "paddingTop": "var(--spacing-md)"
  }]}>
      <_StyledSpan>{group.label}</_StyledSpan>

      <_StyledDiv2>
        {group.options.map(option => <ConfiguratorOptionCard key={option.id} title={option.title} description={option.description} image={option.image} selected={selectedOptionId === option.id} onSelect={() => onSelectOption(option.id)} />)}
      </_StyledDiv2>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-3k2ocq-0"
})`${p => p.$_css}`;
var _StyledSpan = _styled2("span").withConfig({
  componentId: "sc-sf-3k2ocq-1"
})({
  "marginBottom": "var(--spacing-md)",
  "display": "block",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "500",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "500"
  }
});
var _StyledDiv2 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "configurator-accessory-group___StyledDiv2",
  componentId: "sc-o59x2f-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.8rem"
});